import { Fragment } from '@wordpress/element'
import qs from 'qs'
import 'react-popupbox/dist/react-popupbox.css'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { filterPhotos } from '../Functions'
import { PopupboxContainer } from 'react-popupbox'
import SideMenu from './SideMenu'
import SearchForm from './SearchForm'
import Pagination from '../Components/Pagination'
import Results from './Results'

/* eslint no-extend-native: ["error", { "exceptions": ["String"] }] */
String.prototype.slugToUpperCaseWords = function () {
  if (this.valueOf() === 'alitc') {
    return 'ALITC'
  }

  return this.split('-').join(' ').replace(/\w+/g, (a) => {
    return a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()
  })
}

const PhotoSearch = () => {
  const {
    allImages,
    currentAlbum,
    currentPage,
    isAdmin
  } = /** @type {PhotoSearchDataSet} */ window.PhotoSearchData
  const varNames = {
    allImages: 'allImages',
    academyTimeframe: 'academyTimeframe',
    category: 'category',
    callback: 'filterNewGalleryPhotos',
    classmates: 'classmates',
    companies: 'companies',
    decade: 'decade',
    service: 'service',
    serviceBranch: 'serviceBranch',
    subsection: 'subsection',
    year: 'year'
  }
  const initialValues = qs.parse(window.location.hash.replace('#', ''))

  if (isAdmin) {
    console.log(initialValues)
  }

  const initialPhotos = filterPhotos({
    state: {
      allImages,
      academyTimeframe: initialValues.academyTimeframe ?? '',
      category: currentAlbum ?? '',
      classmates: initialValues.classmates ?? '',
      companies: initialValues.companies ?? '',
      decade: initialValues.decade ?? '',
      service: initialValues.service ?? '',
      serviceBranch: initialValues.serviceBranch ?? '',
      subsection: initialValues.subsection ?? '',
      year: initialValues.year ?? ''
    },
    varNames
  })

  const [state, setState] = useState({
    allImages,
    page: currentPage,
    academyTimeframe: '',
    category: currentAlbum,
    classmates: initialValues.classmates ?? '',
    companies: initialValues.companies ?? '',
    decade: initialValues.decade ?? '',
    lastPage: (() => Math.ceil(initialPhotos.length / 60))(),
    isAdmin,
    items: initialPhotos,
    service: initialValues.service ?? '',
    serviceBranch: initialValues.serviceBranch ?? '',
    subsection: initialValues.subsection ?? '',
    year: initialValues.year ?? '',
    modalIsOpen: false,
    selectedIndex: null
  })

  return (
    <Fragment>
      <SideMenu
        state={state}
        setState={(state) => setState(state)}
        varNames={varNames}
      />
      <div className='photos-shell'>
        <SearchForm
          state={state}
          setState={(state) => setState(state)}
          varNames={varNames}
        />
        <Pagination
          includePageCount
          state={state}
          setState={(state) => setState(state)}
          varNames={varNames}
        />
        <Results
          state={state}
          setState={(state) => setState(state)}
          varNames={varNames}
        />
        <Pagination
          state={state}
          setState={(state) => setState(state)}
          varNames={varNames}
          inApprovalFooter
        />
        <PopupboxContainer />
      </div>
    </Fragment>
  )
}

if (document.getElementById('usna1978_photo_search')) {
  const photoSearchRoot = ReactDOM.createRoot(document.getElementById('usna1978_photo_search'))
  photoSearchRoot.render(<PhotoSearch />)
}
